// react-router-dom components
import { NavLink } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import MapIcon from '@mui/icons-material/Map';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftProgress from "components/SoftProgress";
import SoftBadge from "components/SoftBadge";
import StatusCell from "../components/StatusCell";

import { setSelectedDriver } from "context";
import { assignTasks, getDriverCoords } from 'actions';
import SoftTypography from "components/SoftTypography";

export const driverData = (deliveries, pickups, setMapModalVisible, dispatch, user, setToaster, date) => {
  return ([
    { // for expanding rows
      id: "expander", width: "1%", disabled: true,
      Cell: ({ row }) => { // Use Cell to render an expander for each row. We can use the getToggleRowExpandedProps prop-getter to build the expander.
        return (<SoftBox {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? <Icon>expand_less</Icon> : <Icon>expand_more</Icon>}
        </SoftBox>)
      }
    },
    { Header: "driver", accessor: "label" },
    { Header: "division", accessor: "division" },
    {
      Header: "deliveries (complete/total)", width: "10%", id: 'delivery',
      accessor: row => `${deliveries.filter(d => d.driver === row.email && d.completed).length}/${deliveries.filter(d => d.driver === row.email).length}`,
    },
    {
      Header: "pick-ups (complete/total)", width: "10%", id: 'pickup',
      accessor: row => `${pickups.filter(p => p.driver === row.email && p.completed).length}/${pickups.filter(p => p.driver === row.email).length}`,
    },
    {
      Header: "progress", id: 'progress', accessor: row => {
        let driverDeliveries = deliveries.filter(d => d.driver === row.email);
        let driverPickups = pickups.filter(p => p.driver === row.email);
        let completedDeliveries = driverDeliveries.filter(d => d.completed).length;
        let completedPickups = driverPickups.filter(p => p.completed).length;
  
        let total = driverDeliveries.length + driverPickups.length;
        let percent = total === 0 ? 0 : ((completedDeliveries + completedPickups) / total) * 100;
  
        return Math.round(percent);
      },
      Cell: ({ value }) => {
        return (
          <SoftBox width="8rem" textAlign="left">
            <SoftProgress value={value} color="info" variant="gradient" label={true} />
          </SoftBox>
        );
      }
    },
    {
      id: 'actions', Header: 'actions', width: "5%", disabled: true,
      Cell: ({ row }) => {
        const data = row.original;
        return (<SoftBox>
          <IconButton color="primary" title="View Driver Map" aria-label="View Driver Map" onClick={async () => {
            if (data.coords) {
              setSelectedDriver(dispatch, data);
              setMapModalVisible(true);
            }
            else {
              let coords = await getDriverCoords(data.email);
              if (!coords) {
                alert('Location Coordinates are not available for this driver');
              }
              else {
                data.coords = coords;
                setSelectedDriver(dispatch, data);
                setMapModalVisible(true);
              }
            }
          }} > <MapIcon /> </IconButton>

          <NavLink to="/drivers" key="drivers"> <IconButton color="primary" title="Edit Tasks" aria-label="Edit Tasks"
            onClick={() => { setSelectedDriver(dispatch, data); }}> <EditIcon /> </IconButton> </NavLink>

          <IconButton color="primary" title="Remove All Tasks" aria-label="Delete Tasks" onClick={() => {
            if (window.confirm('Remove all tasks from this driver?')) { assignTasks(data, user.email, [], [], date); setToaster(true); }
          }}> <DeleteIcon /> </IconButton>
        </SoftBox>)
      }
    },
  ]);
}

export const taskData = [
  {
    Header: '', width: "1%", id: 'blank',
    disabled: true,
  },
  {
    Header: 'Order(s)',
    accessor: row => row.orders.map(o => o.id).join(',')
  },
  {
    Header: 'RA #',
    accessor: row => row.type === 'PICKUP' ? row.returnAuthId : ''
  },
  {
    Header: 'Type', accessor: 'type', id: 'type',
    Cell: ({ row }) => {
      const data = row.original;
      let status;

      if (data.type === "DELIVERY") status = <StatusCell icon="local_shipping" color={data.completed ? "success" : "error"} status={data.type} />;
      else status = <StatusCell icon="pin_drop" color={data.completed ? "success" : "error"} status={data.type} />;

      return status;
    },
  },
  {
    Header: 'Customer',
    accessor: row => `${row.customer.lastName}, ${row.customer.firstName}`
  },
  {
    Header: 'Company',
    accessor: 'customer.company',
  },
  {
    Header: 'Address',
    accessor: row => `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`
  },
  {
    Header: 'Status', id: 'status',
    accessor: row => row.completed ? 'COMPLETE' : 'OPEN',
    Cell: ({ row }) => {
      const data = row.original;
      return (data.completed ?
        <SoftBadge color="success" variant="contained" badgeContent="complete" container /> :
        <SoftBadge color="error" variant="contained" badgeContent="open" container />);
    }
  }
];

export const unassignedTaskData = (assignTask) => {
  return [
    {
      Header: '', width: "1%", id: 'blank',
      disabled: true,
    },
    {
      Header: 'Order(s)',
      accessor: row => row.orders.map(o => o.id).join(',')
    },
    {
    Header: 'RA #',
    accessor: row => row.type === 'PICKUP' ? row.returnAuthId : ''
    },
    {
      Header: 'Type', accessor: 'type', id: 'type',
      Cell: ({ row }) => {
        const data = row.original;
        let status;
  
        if (data.type === "DELIVERY") status = <StatusCell icon="local_shipping" color={data.completed ? "success" : "error"} status={data.type} />;
        else status = <StatusCell icon="pin_drop" color={data.completed ? "success" : "error"} status={data.type} />;
  
        return status;
      },
    },
    {
      Header: 'Customer',
      accessor: row => `${row.customer.lastName}, ${row.customer.firstName}`
    },
    {
      Header: 'Company',
      accessor: 'customer.company',
    },
    {
      Header: 'Address',
      accessor: row => `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`
    },
    {
      id: 'actions', Header: 'actions', width: "5%", disabled: true,
      Cell: ({ row }) => {
        const data = row.original;
        return (
        <SoftBox style={{cursor: 'pointer'}} onClick={() => assignTask(data)}>
          <SoftTypography variant="caption" fontWeight="bold">
              Assign Task
          </SoftTypography>
        </SoftBox>)
      }
    }
  ]
};
